import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import { Col, Row, Button } from "reactstrap";
import Header from "../../layout/Header/Header";

function BotonesDashboards() {
  const { user } = useContext(AuthContext);
  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_reportes ? (
      <div className="container">
          <Row>

          <Col md={4} align="center">
                    {user.menu_reportes ?(
                      <Button href="/DashboardCompras" className="botonesMenu" color="success">
                        <i class="fas fa-cart-plus fa-7x"></i>
                        <br />
                        <br />
                        Dashboard Compras
                      </Button>
                    ): <Button disabled className="botonesMenu" color="success">
                    <i class="fas fa-cart-plus fa-7x"></i>
                    <br />
                    <br />
                    Dashboard Compras
                  </Button> }
                    </Col>


          <Col md={4} align="center">
                    {user.menu_reportes ?(
                      <Button href="/DashboardCXP" className="botonesMenu" color="success">
                        <i class="fas fa-chart-bar fa-7x"></i>
                        <br />
                        <br />
                        Dashboard CXP
                      </Button>
                    ): <Button disabled className="botonesMenu" color="success">
                    <i class="fas fa-chart-bar fa-7x"></i>
                    <br />
                    <br />
                    Dashboard CXP
                  </Button> }
                    </Col>

                    <Col md={4} align="center">
          {user.menu_reportes ?(
            <Button href="/DashboardInventarios" className="botonesMenu" color="success">
              <i class="fas fa-tshirt fa-7x"></i>
              <br />
              <br />
              Dashboard Inventarios
            </Button>
          ): <Button disabled className="botonesMenu" color="success">
          <i class="fas fa-tshirt fa-7x"></i>
          <br />
          <br />
          Dashboard Inventarios
        </Button> }
          </Col>

          </Row>
            <br />
            <br />
            <Row>
              
          <Col md={4} align="center">
          {user.menu_reportes ?(
            <Button href="/DashboardVentas" className="botonesMenu" color="success">
               <i class="fas fa-signal fa-7x"></i>
              <br />
              <br />
              Dashboard Ventas
            </Button>
          ): <Button disabled className="botonesMenu" color="success">
           <i class="fas fa-signal fa-7x"></i>
          <br />
          <br />
          Dashboard Ventas
        </Button> }
          </Col>


            <Col md={4} align="center">
          {user.menu_reportes ?(
            <Button href="/DashboardCobranza" className="botonesMenu" color="success">
               <i class="fas fa-dollar-sign fa-7x"></i>
              <br />
              <br />
              Dashboard Cobranza
            </Button>
          ): <Button disabled className="botonesMenu" color="success">
           <i class="fas fa-dollar-sign fa-7x"></i>
          <br />
          <br />
          Dashboard Cobranza
        </Button> }
          </Col>

          <Col md={4} align="center">
          {user.menu_reportes ?(
            <Button href="/DashboardTiendas" className="botonesMenu" color="success">
               <i class="fas fa-store fa-7x"></i>
              <br />
              <br />
              Dashboard Tiendas
            </Button>
          ): <Button disabled className="botonesMenu" color="success">
           <i class="fas fa-store fa-7x"></i>
          <br />
          <br />
          Dashboard Tiendas
        </Button> }
          </Col>

            </Row>
            <br />
            <Row>
          

          
          <Col md={4} align="center">
          {user.menu_reportes ?(
            <Button href="/DashboardGastos" className="botonesMenu" color="success">
               <i class="fas fa-hand-holding-usd fa-7x"></i>
              <br />
              <br />
              Dashboard Gastos
            </Button>
          ): <Button disabled className="botonesMenu" color="success">
           <i class="fas fa-hand-holding-usd fa-7x"></i>
          <br />
          <br />
          Dashboard Gastos
        </Button> }
          </Col>

          <Col md={4} align="center">
          {user.menu_reportes ?(
            <Button href="/Balance" className="botonesMenu" color="success">
               <i class="fas fa-chart-line fa-7x"></i>
              <br />
              <br />
              Balance
            </Button>
          ): <Button disabled className="botonesMenu" color="success">
           <i class="fas fa-chart-line fa-7x"></i>
          <br />
          <br />
          Balance
        </Button> }
          </Col>
            </Row>
      </div>
      ) : undefined}
    </>
  );
}

export default BotonesDashboards;
